/** Reset page scroll (window + common app scroll parents). */
export const scrollAppToTop = () => {
  window.scrollTo(0, 0);
  const selectors = ['html', 'body', '#root', '.app-container', '.main-content'];
  selectors.forEach((sel) => {
    const el = document.querySelector(sel);
    if (el && typeof el.scrollTop === 'number') {
      el.scrollTop = 0;
    }
  });
};
